import {Constant} from "./index";
import {STATE} from "../../Type";

export class Animation extends Constant {
  get type() {
    return "Animation";
  }

  get category() {
    return "Constant";
  }

  static getPrototypeBlocks(animationIds) {
    const prototypeBlocks = [];
    for (let i = 0; i < animationIds.length; i++) {
      const animationId = animationIds[i];
      prototypeBlocks.push(
        new Animation({data: animationId, state: STATE.PROTOTYPE}),
      );
    }
    return prototypeBlocks;
  }
}
